// Root domain sign-in: asks for the company's address and sends the user there.
import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { InputField, PrimaryButton } from "ui";
import { Link } from "lib/router";
import { QaydLogo } from "components/Brand";
import SaasServices from "services/Saas";
import { ROOT_DOMAIN, companyUrl } from "config/tenant";

export default function FindCompany() {
  const [slug, setSlug] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const value = slug.trim().toLowerCase();
    if (!value) return setError("Enter your company's address.");
    setLoading(true);
    setError("");
    try {
      await SaasServices.companyInfo(value);
      window.location.href = companyUrl(value, "/login");
    } catch {
      setError("We couldn't find a company at that address.");
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-4">
      <div className="w-full max-w-[400px]">
        <QaydLogo size={32} />
        <h1 className="m-0 mt-8 text-[22px] font-semibold tracking-[-0.02em] text-fg">Sign in to your company</h1>
        <p className="m-0 mt-1.5 text-[14px] text-muted">Enter your company's Qayd address.</p>
        <form onSubmit={submit} className="mt-6 rounded-[var(--radius-card)] border border-line bg-panel p-5 shadow-[var(--shadow-card)]">
          <InputField
            label="Company address"
            placeholder="your-company"
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
            endAdornment={<span className="text-[13px] whitespace-nowrap text-faint">.{ROOT_DOMAIN}</span>}
            error={error}
          />
          <PrimaryButton title="Continue" type="submit" loading={loading} fullWidth endIcon={<ArrowRight />} />
        </form>
        <p className="m-0 mt-5 text-center text-[13.5px] text-muted">
          New to Qayd? <Link to="/signup" className="font-medium text-accent no-underline">Create your company</Link>
        </p>
      </div>
    </div>
  );
}
